import React from 'react';

const AboutList = ({ sections, onEdit, onDelete, isLoading }) => {
  if (isLoading) return <div className="p-4 text-center text-gray-500">Loading...</div>;
  if (!sections.length) return <div className="p-4 text-center text-gray-400">No about sections yet.</div>;

  return (
    <div className="space-y-4">
      {sections.map(section => (
        <div key={section.id} className="bg-white rounded shadow p-4 flex flex-col md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-lg font-bold mb-1">{section.title}</h2>
            <p className="text-gray-600">{section.content}</p>
          </div>
          <div className="flex gap-2 mt-2 md:mt-0">
            <button
              className="px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 text-sm"
              onClick={() => onEdit(section)}
            >
              Edit
            </button>
            <button
              className="px-3 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200 text-sm"
              onClick={() => onDelete(section)}
            >
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AboutList; 